import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { State } from '../redux';

const VisitsFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['emConfiguration']['visits'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};

const VisitsConfiguration: React.FC<Props> = (props) => {
  const { fieldDisabled, visitThreshold } = props;

  return (
    <Box>
      <Box my={4}>
        <VisitsFormInput
          id='visitThreshold'
          label='Visits'
          readonly={fieldDisabled('visitThreshold')}
          type='text'
          value={visitThreshold}
          required={true}
        />
      </Box>
    </Box>
  );
};

export { VisitsConfiguration };
